import PropTypes from 'prop-types';
import styles from './index.module.less';

const PasswordRequirements = ({ style }) => (
  <div className={styles.passwordRequirements} style={style}>
    <p>
      <strong>Password Requirements:</strong>
    </p>
    <ul>
      <li>Must be a minimum of 12 characters and a maximum of 64 characters.</li>
      <li>Must contain both upper and lower case characters (e.g., a-z, A-Z).</li>
      <li>Have at least one punctuation mark and/or special character (e.g., @#$%^&*()_).</li>
      <li>Have at least one digit (e.g., 0–9).</li>
      <li>Must not be reused.</li>
    </ul>
  </div>
);

PasswordRequirements.propTypes = {
  style: PropTypes.object,
};

export default PasswordRequirements;
